import { skipToken, useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../zodios/client";

/**
 * Confirms the signed-in user's email with the token from a verification link. A query rather than
 * a mutation, so a page can start it from render and it runs once per token. The endpoint needs
 * the signed-in user, so only call this below the layouts that restore the session.
 */
export const useVerifyEmail = (token: string | undefined) => {
  return useQuery({
    queryKey: ["verifyEmail", token],
    queryFn: token === undefined ? skipToken : async () => await apiClient.confirmEmail({ token }),
    retry: false,
    staleTime: Infinity,
  });
};
